/**
 * @desc 绑定微信
 */
import { UserEntity, BindWechatForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type BindWechatParameter = BindWechatForm

const method = 'GET'
const url = '/auth/wechat/bind'

export const bindWechatApi = (
  params?: BindWechatParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<UserEntity>({
    method,
    url,
    params,
    ...config
  })
}

bindWechatApi.method = method
bindWechatApi.url = url
